require('./bootstrap');

window.Vue = require('vue');
import Vuex from 'vuex';

import Swal from 'sweetalert2/dist/sweetalert2.js';

//Vue Select
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
// Set the components prop default to return our fresh components
Vue.component('v-select', vSelect);

//Calendar
import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
    datePicker:{popover:{visibility:'focus'}},
});

import flatpickr from "flatpickr";
import { Portugues } from "flatpickr/dist/l10n/pt.js";
flatpickr.localize(Portugues);
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.component('v-datetimepicker', flatPickr);

//Mask
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import moment from 'moment-timezone'; //Formatos : https://momentjs.com/docs/#/displaying/format/
require('moment/locale/pt-br');
Vue.use(require('vue-moment'), {moment});
moment.tz.setDefault("America/Sao_Paulo");

//Mask Money
import money from 'v-money'
Vue.use(money, {precision: 2});

//Vue-noty
import VueNoty from 'vuejs-noty';
import 'vuejs-noty/dist/vuejs-noty.css';
Vue.use(VueNoty,{layout: 'bottomRight', theme: 'bootstrap-v4', progressBar: true, timeout:2000});

//Tiny Editor de Texto
import Editor from '@tinymce/tinymce-vue'

//Vuex
const store = new Vuex.Store({
    state:{
        alerta:{},
        anexo:{},
        contrato:{},
        cliente:{},
        config:{},
        convenio_federal_selecionado: null,
        editorKey:null,
        // FISCAIS E GESTORES DE CONTRATO (PRD #33 / issue #52).
        // As chaves nascem DECLARADAS aqui, com o formato completo, de proposito: chave criada
        // depois em `$store.state.form` (ou em qualquer objeto ja observado) nao e reativa no
        // Vue 2 — `set_state` substitui o objeto e a propriedade nova fica invisivel. E a
        // armadilha que morde exatamente em lista dinamica. Declarando tudo aqui, nenhum ponto
        // de escrita do modal precisa de $set: as escritas ou trocam o objeto inteiro, ou usam
        // push/splice (que o Vue 2 intercepta).
        fiscais:{id_contrato:null,contrato:{},vinculos:[],encerrados:[],erro:null},
        fiscais_busca:{busca:'',resultados:[],feita:false},
        fiscal_novo:{nome:'',cpf:'',matricula:'',aberto:false,erro:null},
        form:{},
        function:{},
        nav:false,
        notas:{},
        lista:{},
        modal:{},
        movimentacao:{},
        movimentacoes:[],
        pauta:[],
        materias_pauta:[],
        form_pauta:{},
        presencas:[],
        // Select de legislatura da LISTA DE PRESENCA (grade por roster). `legislatura`/`aviso`/
        // `carregada` vem do envelope de presencas/get; declarados aqui pela mesma razao acima.
        presenca_filtro:{id_legislatura:null,legislatura:null,aviso:null,carregada:false},
        // VOTACAO POR SESSAO (PRD #30 / issues #34 e #35).
        // As chaves nascem DECLARADAS aqui, com o formato completo: `set_state` substitui o
        // objeto inteiro e o Vue 2 nao observa propriedade criada depois. `id_plenario_sessao`
        // e `carregada` sao exatamente esse caso — sem declaracao, o seletor de sessao e o
        // estado vazio da grade nao reagiriam.
        sessoes:[],
        votacao:{id_materia_tipo:null,id_materia:null,id_plenario_sessao:null},
        // Selecao de sessao do CARD DE VOTACAO do modal da materia (issue #36). Chave propria
        // (nao reusa `votacao`) para o modal e a tela /legislativo/votacao nao dividirem a
        // selecao: `votacao` guarda tipo+materia+sessao da tela dedicada; aqui so a sessao,
        // porque a materia ja e a do modal (`form.id_materia`). A grade em si continua em
        // `votacao_grade` — e o unico state compartilhado, resetado ao abrir/fechar o modal.
        votacao_modal:{id_plenario_sessao:null,sessoes_carregadas:false},
        // `carregada` distingue "ainda nao carregou" de "carregou e a sessao nao tem presenca".
        votacao_grade:{votos:[],placar:[],carregada:false},
        materias_tramitacao:[],
        obra:{},
        ordem:{},
        paginate:{},
        processo:{},
        pncp:{},
        fornecedor:{},
        request:{},
        relatorio:{},
        subnav:false,
        subtab:false,
        tab:false,
        unidade:{},
        // VERBA DE GABINETE (PRD #32 / issue #46).
        // As chaves nascem DECLARADAS aqui, com o formato completo, como em `fiscais` e
        // `votacao_grade`: os handlers trocam o objeto inteiro ou escrevem em chave ja
        // existente, e o Vue 2 nao observa propriedade criada depois — a grade de valores
        // por vereador e exatamente a lista dinamica que quebraria sem isto.
        // `carregada` distingue "ainda nao carregou" de "carregou e veio vazio";
        // `carregando` segura o estado vazio enquanto o lote/get esta no ar.
        verba_lote:{mes_competencia:null,ano_competencia:null,data_repasse:null,legislatura:null,vereadores:[],lancamentos:[],carregada:false,carregando:false,aviso:null,erro:null},
        verba_lei:{carregada:false},
        // RECEITAS: ORCAMENTO ANUAL (adendo da PRD #32).
        // `ano` e a UNICA fonte do ano filtrado na tela: o card e a tabela leem
        // daqui, para os dois numeros do card nunca falarem de um ano diferente
        // do da lista. Nasce no ano corrente. As demais chaves nascem
        // declaradas pelo mesmo motivo de `verba_lote` (Vue 2 nao observa chave
        // criada depois).
        receita_orcamento:{ano:(new Date()).getFullYear(),orcamento_anual:null,acumulado:0,saldo:null,percentual:null,anos:[],carregada:false,erro:null},
        // Vereadores ativos para selects/filtros. As Comissoes ja escrevem aqui via
        // set_state:'vereadores'; declarado para a troca do array ser reativa tambem
        // no primeiro load (chave criada depois no state raiz nao e observada).
        vereadores:[],
        waiting_request:false,
    },
    mutations:{
        setProcesso(state,obj){state.processo = obj;},
    }
});

//COMPONENTES (A - Z)
Vue.component('anexos', require('./components/plugins/Anexos').default);
Vue.component('busca-3', require('./components/recursos/Busca-3').default);
Vue.component('card-anexo-lista', require('./components/anexos/CardAnexoLista').default);
Vue.component('chart-donut', require('./components/charts/Chart-Donut').default);
Vue.component('chart-line', require('./components/charts/Chart-Line').default);
Vue.component('chart-bar', require('./components/charts/Chart-Bar').default);
Vue.component('convenio-federal-detalhe-modal', require('./components/convenios-federais/ConvenioFederalDetalheModal').default);
Vue.component('dropdown', require('./components/recursos/Dropdown').default);
Vue.component('endereco-2', require('./components/recursos/Endereco-2').default);
Vue.component('form-export', require('./components/formularios/FormExport').default);
Vue.component('form-steps', require('./components/formularios/FormSteps').default);
Vue.component('gerenciador-request', require('./components/recursos/GerenciadorRequests').default);
Vue.component('lista-com-anexo-fallback', require('./components/anexos/ListaComAnexoFallback').default);
Vue.component('loading', require('./components/plugins/Loading').default);
Vue.component('modal-3', require('./components/modal/Modal-3').default);
Vue.component('paginate', require('./components/tabelas/Paginate').default);
Vue.component('password-confirm', require('./components/recursos/PasswordConfirm').default);
Vue.component('request', require('./components/recursos/Request').default);
Vue.component('tabela-6', require('./components/tabelas/Tabela-6').default);
Vue.component('upload-files', require('./components/plugins/Upload-files').default);

//busEvent
export const bus = new Vue();
//Loaders
import { HollowDotsSpinner } from 'epic-spinners';

import _ from 'lodash';

Vue.prototype.$swal = Swal;

const app = new Vue({
    el: '#app',
    store,
    data: function () {
        return {
            flash:null,
            form:null,
            action:{},
            files:null,
            grupo:null,
            grafico:null,
            nav:null,
            render:true,
            relatorio:{},
            subnav:null,
            subtab:null,
            tab:null,
            _buscar:null,
        }
    },
    components: {
        HollowDotsSpinner,
        editor:Editor
    },
    methods:{
        gerenciadorRequest: (obj) => {
            bus.$emit('gerencia-request',obj);
        },
        busEmit: (emit,timeout = 0,event = null) => {
            setTimeout(() => {if(typeof emit === 'string'){bus.$emit(emit,event);}else if(typeof emit === 'object'){bus.$emit(emit.emit,emit.obj)}},timeout);
        },
        addObjectToState(state,obj){
            let st = {};
            for(var key in this.$store.state[state]){
                st[key] = this.$store.state[state][key];
            }
            for (var keyObj in obj){
                st[keyObj] = obj[keyObj];
            }
            this.$store.state[state] = st;
        },
        focusId(id_elemento,timeout = 200){
            setTimeout(function(){
                if(typeof id_elemento === 'string'){
                    if(document.getElementById(id_elemento)){
                        document.getElementById(id_elemento).focus()
                    }
                }else{
                    for(let id in id_elemento){
                        if(document.getElementById(id_elemento[id])){
                            document.getElementById(id_elemento[id]).focus();
                            break;
                        }
                    }
                }
            },timeout);
        },
        getElementById(id_elemento){
            return document.getElementById(id_elemento);
        },
        click(id_elemento,timeout = 200){
            setTimeout(function(){
                if(document.getElementById(id_elemento)){
                    document.getElementById(id_elemento).click()
                }
            },timeout);
        },
        redirect(obj){
            this.$noty.info('Redirecionando...',{layout: 'bottomCenter', timeout:2000});
            if(typeof obj === 'string'){window.location.href = obj;}
            else{//Verificando a opção de montar URL
                if(obj.montar_url){
                    obj.url = '';
                    for(let part in obj.montar_url){
                        if(obj.montar_url[part].valor){obj.url+= obj.montar_url[part].valor;}
                        else if(obj.montar_url[part].state){obj.url+= this.$store.state[obj.montar_url[part].state][obj.montar_url[part].chave];}
                    }
                }
                window.location.href = obj.url;
            }
        },
        limitText(string,limit){
            if(string && string.length >= limit){
                return string.substring(0,limit) + '...';
            }else{
                return string;
            }
        },
        onSearchVueSelect(search, loading,request,lista_key) {
            if(search.length > 0) {
                loading(true);
                this.search(search,loading,request,lista_key, this);
            }
        },
        search: _.debounce((search,loading,request,lista_key, vm) => {
            // vm.$options.data = {nome:'Testando',id_unidade:1};
            axios({
                url: request.url,
                method: 'POST',
                data: request.data
            })
                .then(res => {
                    var obj = {};
                    obj[lista_key] = res.data;
                    vm.addObjectToState('lista', obj);
                });

            loading(false);
        }, 1500),
        featherIcons(){setTimeout(function (){feather.replace();},200)},
        inputRequired(){
            setTimeout(function (){
                var el = $("label.required ~ div,label.required ~ span, label ~ input:required, label ~ select:required, label ~ textarea:required").parent().find('label').not('.required_input');
                el.addClass('required_input');
                el.append('<span class=\'text-danger\' title=\'Campo obrigatório\'>&nbsp;*</span>');
            },500);
        },
        exportar(obj){bus.$emit('form-export',obj);},
        confirmAlert(obj){bus.$emit('confirm-alert',obj);},
        noty(obj){
            if(obj.noty === 'warning'){
                this.$noty.warning(obj.content,{layout:'center', timeout:2000});
            }
        },
        baixar(obj){bus.$emit('form-download',obj);},
        downloadPDF(obj){bus.$emit('download-pdf',obj);},
        renderChart(obj){bus.$emit('render-chart',obj);},
        sincronizarConveniosFederais(full = false){
            const params = full ? { full: 1 } : {};
            window.axios.post('/convenios-federais/sync', null, { params })
                .then(() => {
                    this.$noty.success(full
                        ? 'Re-sincronizacao completa enfileirada. O resultado aparece nos proximos minutos.'
                        : 'Sincronizacao enfileirada. O resultado aparece nos proximos minutos.');
                })
                .catch((err) => {
                    const msg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : err.message;
                    this.$noty.error('Erro ao enfileirar: ' + msg);
                });
        },
        abrirDetalheConvenioFederal(id){
            this.$store.state.convenio_federal_selecionado = id;
            bus.$emit('show_modal-modal_convenio_federal_detalhe', {});
        },
        badgeSituacaoConvenio(situacao){
            const s = (situacao || '').toLowerCase();
            if (s.indexOf('execu') >= 0) return 'success';
            if (s.indexOf('conclu') >= 0) return 'info';
            if (s.indexOf('rescind') >= 0 || s.indexOf('anula') >= 0) return 'danger';
            if (s.indexOf('suspens') >= 0) return 'warning';
            return 'secondary';
        },
        detalhePendenteConvenio(row){
            if (!row.detalhe_sincronizado_em) return true;
            if (row.lista_sincronizada_em && row.lista_sincronizada_em > row.detalhe_sincronizado_em) return true;
            return false;
        },
        // ------------------------------------------------------------------
        // FISCAIS E GESTORES DE CONTRATO (PRD #33 / issue #52)
        //
        // O vinculo e POR CONTRATO/ARP (art. 117 da Lei 14.133/2021), entao todo o estado do
        // modal gira em torno de um instrumento so. A lista `fiscais.vinculos` e o CONJUNTO
        // que a tela manda em /contratos/fiscais/sincronizar — uma requisicao, nunca uma por
        // linha. Quem sai do conjunto e ENCERRADO pelo backend (soft delete + data_fim), por
        // isso o historico continua visivel em `fiscais.encerrados`.
        // ------------------------------------------------------------------
        hojeISO(){
            let d = new Date();
            let mes = String(d.getMonth() + 1).padStart(2,'0');
            let dia = String(d.getDate()).padStart(2,'0');
            return d.getFullYear() + '-' + mes + '-' + dia;
        },
        // ------------------------------------------------------------------
        // VERBA DE GABINETE (PRD #32 / issue #46)
        // ------------------------------------------------------------------
        // Reset unico do estado do lote: o formato canonico vive so aqui e na
        // declaracao do state. Espalhar o literal pelas views e o caminho curto
        // para uma chave nova ficar de fora de um dos resets e voltar o bug de
        // reatividade que a declaracao previa existe para evitar.
        resetVerbaLote(){
            this.$store.state.verba_lote = {mes_competencia:null,ano_competencia:null,data_repasse:null,legislatura:null,vereadores:[],lancamentos:[],carregada:false,carregando:false,aviso:null,erro:null};
        },
        // ------------------------------------------------------------------
        // RECEITAS: ORCAMENTO ANUAL (adendo da PRD #32)
        // ------------------------------------------------------------------
        // Troca o ano da tela inteira: card e tabela. Reescreve a url a partir
        // da uri (mesmo passo do updateFilter do Busca-3, que zera a pagina) e
        // recarrega os dois. Usado quando o ano muda FORA do filtro — ao salvar
        // o orcamento de outro ano, a tela acompanha o que acabou de ser feito.
        setAnoReceitas(ano){
            this.$store.state.receita_orcamento.ano = ano;
            let tabela = this.$store.state.request['tabela_receitas'];
            if(tabela && tabela.data){
                tabela.data.ano = ano;
                tabela.url = tabela.uri;
            }
            bus.$emit('refresh-tabela_receitas');
            bus.$emit('refresh-orcamento_get');
        },
        // Valor mascarado pelo v-money ("1.500,00") ou cru da API ("1500.00")
        // para numero — so para logica de tela (badge/disabled); o backend
        // sanitiza de novo antes de validar.
        valorNumerico(valor){
            return parseFloat(String(valor || '0').replace(/\./g,'').replace(',','.'));
        },
        msgErroRequest(data,fallback){
            if(data && data.errors){
                for(let chave in data.errors){
                    if(data.errors[chave] && data.errors[chave].length){return data.errors[chave][0];}
                }
            }
            if(data && data.msg){return data.msg;}
            if(data && data.message){return data.message;}
            return fallback;
        },
        fiscaisLimparBusca(){
            this.$store.state.fiscais_busca = {busca:'',resultados:[],feita:false};
            this.$store.state.fiscal_novo = {nome:'',cpf:'',matricula:'',aberto:false,erro:null};
            // Zera as opcoes do v-select para o modal nao reabrir com o resultado da busca anterior.
            this.addObjectToState('lista',{fiscais:[]});
        },
        fiscaisAbrirModal(contrato){
            this.$store.state.fiscais = {
                id_contrato:contrato.id_contrato,
                contrato:contrato,
                vinculos:[],
                encerrados:[],
                erro:null
            };
            this.fiscaisLimparBusca();
            bus.$emit('show_modal-modal_fiscal');
            bus.$emit('refresh-get_fiscais_contrato');
        },
        // Resposta de /contratos/fiscais/list com historico:true — vigentes viram a lista
        // editavel; encerrados ficam so de leitura (nunca somem da tela).
        fiscaisCarregarVinculos(linhas){
            let lista = Array.isArray(linhas) ? linhas : [];
            this.$store.state.fiscais.vinculos = lista.filter(l => l.ativo).map(l => ({
                id_fiscal_contrato:l.id_fiscal_contrato,
                id_fiscal:l.id_fiscal,
                nome:l.nome,
                papel:Number(l.papel),
                data_inicio:l.data_inicio,
                data_fim:l.data_fim || null
            }));
            this.$store.state.fiscais.encerrados = lista.filter(l => !l.ativo);
        },
        // Identidade da designacao = (pessoa, papel). Duplicata exata seria 422 no backend;
        // barrar aqui evita a ida ao servidor sem esconder a regra.
        fiscaisAdicionar(pessoa,papel = 1){
            let lista = this.$store.state.fiscais.vinculos;
            if(lista.some(v => Number(v.id_fiscal) === Number(pessoa.id_fiscal) && Number(v.papel) === Number(papel))){
                this.$noty.warning('Esta pessoa já está na lista com este papel. Ajuste o papel na linha existente.',{layout:'center', timeout:3000});
                return false;
            }
            lista.push({
                id_fiscal_contrato:null,
                id_fiscal:pessoa.id_fiscal,
                nome:pessoa.nome,
                papel:Number(papel),
                data_inicio:this.hojeISO(),
                data_fim:null
            });
            this.$store.state.fiscais.erro = null;
            this.fiscaisLimparBusca();
        },
        fiscaisRemover(index){
            this.$store.state.fiscais.vinculos.splice(index,1);
        },
        // Nao achou ninguem: o cadastro abre ja com o que o usuario digitou (nome ou CPF),
        // para nao obrigar a redigitar.
        fiscaisAbrirCadastro(){
            let termo = (this.$store.state.fiscais_busca.busca || '').trim();
            let digitos = termo.replace(/\D/g,'');
            let so_numeros = termo.length > 0 && /^[\d.\-\s]+$/.test(termo);
            let novo = {nome:'',cpf:'',matricula:'',aberto:true,erro:null};

            if(!so_numeros){novo.nome = termo;}
            else if(digitos.length === 11){novo.cpf = termo;}
            else if(digitos.length > 0){novo.matricula = termo;}

            this.$store.state.fiscal_novo = novo;
            this.focusId(novo.nome ? 'cpf' : 'fiscal-nome',400);
        },
        fiscaisFecharCadastro(){
            this.$store.state.fiscal_novo = {nome:'',cpf:'',matricula:'',aberto:false,erro:null};
        },
        // /fiscais/save respondeu com o id da pessoa: ela entra na lista, mas o VINCULO so
        // existe depois do "Salvar designações". O modal nao fecha aqui.
        fiscaisPessoaCadastrada(data){
            if(!data || !data.id){return false;}
            let nome = (this.$store.state.fiscal_novo.nome || '').trim();
            this.fiscaisAdicionar({id_fiscal:data.id,nome:nome});
        },
        in_array(search,array){
            var c = 0;
            for (var n in array){
                if(array[n] === search){c++;}
            }
            return c > 0;
        },
        round(value, decimals) {
            return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
        },
        iconeAnexo(format){
            switch (format) {
                case 'jpg':
                case 'JPG':
                case 'jpeg':
                case 'JPEG':
                case 'bmp':
                case 'png':
                case 'PNG':
                    return "<i class='far fa-file-image' style='color: #3498db'></i>";
                case 'doc':
                case 'docx':
                    return "<i class='far fa-file-word text-primary'></i>";
                case 'txt':
                    return "<i class='far fa-file-alt'></i>";
                case 'pdf':
                    return "<i class='far fa-file-pdf text-danger'></i>";
                case 'xls':
                case 'xlsx':
                    return "<i class='fas fa-file-excel text-success'></i>";
                case 'xml':
                    return "<i class='far fa-file-code'></i>";
                case 'zip':
                case 'rar':
                    return "<i class='far fa-file-archive text-muted'></i>";
                default:
                    return "<i class='far fa-file'></i>";
            }
        },
    },
    filters:{
        numberFormat:function (valor,digitos_fracao = null) {
            var options = {};
            if(digitos_fracao){
                options.minimumFractionDigits = digitos_fracao;
                options.maximumFractionDigits = digitos_fracao;
            }
            return new Intl.NumberFormat('pt-BR',options).format(valor);
        },
        dateView(date){
            var parts = date.match(/(\d+)/g);
            var data_view = new Date(parts[0], parts[1]-1, parts[2]);
            let ye = new Intl.DateTimeFormat('pt-BR', { year: 'numeric' }).format(data_view);
            let mo = new Intl.DateTimeFormat('pt-BR', { month: '2-digit' }).format(data_view);
            let da = new Intl.DateTimeFormat('pt-BR', { day: '2-digit' }).format(data_view);
            return `${da}/${mo}/${ye}`;
        },
        cnpj(cnpj){
            //43.210.987/6543-21
            var n1 = cnpj.slice(0, -12);
            var n2 = cnpj.slice(-12, -9);
            var n3 = cnpj.slice(-9, -6);
            var n4 = cnpj.slice(-6, -2);
            var n5 = cnpj.slice(-2);
            return n1 + '.' + n2 + '.' + n3 + '/' + n4 + '-' + n5;
        },
        cpf(cnpj){
            //111.111.111-21
            var n1 = cnpj.slice(0, -8);
            var n2 = cnpj.slice(-8, -5);
            var n3 = cnpj.slice(-5, -2);
            var n4 = cnpj.slice(-2);
            return n1 + '.' + n2 + '.' + n3 + '-' + n4;
        }
    },
    created() {
        bus.$on('download-file', (obj) => {
            this.baixar(obj);
        });

        // FISCAIS E GESTORES (PRD #33 / issue #52) — respostas do modal da aba do processo.
        bus.$on('fiscais-carregados', (data) => {
            this.fiscaisCarregarVinculos(data);
        });
        bus.$on('fiscais-buscados', (data) => {
            this.$store.state.fiscais_busca = Object.assign({},this.$store.state.fiscais_busca,{
                resultados:Array.isArray(data) ? data : [],
                feita:true
            });
        });
        bus.$on('fiscal-cadastrado', (data) => {
            this.fiscaisPessoaCadastrada(data);
        });
        // 422 de CPF invalido/duplicado: a mensagem fica DENTRO do modal e o modal continua
        // aberto (o bus_emit que fecharia so roda no caminho de sucesso).
        bus.$on('fiscal-erro-cadastro', (data) => {
            this.$store.state.fiscal_novo = Object.assign({},this.$store.state.fiscal_novo,{
                aberto:true,
                erro:this.msgErroRequest(data,'Não foi possível cadastrar a pessoa.')
            });
        });
        bus.$on('fiscais-erro-salvar', (data) => {
            this.$store.state.fiscais.erro = this.msgErroRequest(data,'Não foi possível salvar as designações.');
        });
        bus.$on('fiscais-erro-carregar', (data) => {
            this.$store.state.fiscais.erro = this.msgErroRequest(data,'Não foi possível carregar as informações. Tente novamente.');
        });
        // VERBA DE GABINETE (PRD #32 / issue #46): erro de request fica INLINE no
        // bloco onde aconteceu (mesmo padrao dos fiscais) — sem isto, uma falha de
        // rede deixaria o "carregando" preso e o usuario so veria um toast sumindo.
        bus.$on('lei-erro-carregar', (data) => {
            this.$store.state.verba_lei = {carregada:false, erro:this.msgErroRequest(data,'Não foi possível carregar a lei autorizadora. Tente novamente.')};
        });
        // RECEITAS: erro do card de orcamento anual fica INLINE no card, como o
        // da lei autorizadora — sem isto o card ficaria preso em "carregando".
        bus.$on('orcamento-erro-carregar', (data) => {
            this.$store.state.receita_orcamento.carregada = false;
            this.$store.state.receita_orcamento.erro = this.msgErroRequest(data,'Não foi possível carregar o orçamento anual. Tente novamente.');
        });
        bus.$on('lote-erro-carregar', (data) => {
            this.$store.state.verba_lote.carregando = false;
            this.$store.state.verba_lote.carregada = false;
            this.$store.state.verba_lote.erro = this.msgErroRequest(data,'Não foi possível carregar a grade de vereadores. Tente novamente.');
        });
    },
    mounted() {
        document.getElementById('app').style.display = 'block';

        $(document).on('focusin', function(e) {
            if ($(e.target).closest(".tox-dialog").length) {
                e.stopImmediatePropagation();
            }
        });

        $(".hover-collapse-head").hover(
            function() {
                console.log('hover');
                $('.hover-collapse').collapse('show');
            }, function() {
                $('.hover-collapse').collapse('hide');
            }
        );
    }
});
